const palette = {
  primary: {
    main: "#771117"
  },
  secondary: {
    main: '#0A071B',
    light: 'rgba(0, 0, 0, 0.6)'
  },
  wardGray: '#5a5a5a',
  lightGray: 'rgba(0, 0, 0, 0.12)',
  lightGrayOne: 'rgba(0, 0, 0, 0.6)',
  lightGrayTwo: "#E4E7EC",
  lightGrayThree: "#E1DFEC",
  lightGrayFour: "#D0D5DD",
  lightGrayFive: "#667085",
  gray900: "#101828",
  green: '#388277',
  red: '#fc5e5e',
  darkRed: '#771117',
  darkOne: "rgba(0, 0, 0, 0.87)",
  navyBlue: '#0074D4',
}

export default palette;